/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1SsoimageIdVideoMutationRequest,
  PostApiV1SsoimageIdVideoMutationResponse,
  PostApiV1SsoimageIdVideoPathParams,
  PostApiV1SsoimageIdVideo400,
  PostApiV1SsoimageIdVideo401,
  PostApiV1SsoimageIdVideo404,
  PostApiV1SsoimageIdVideo500,
} from "../../types/SSOImageController/PostApiV1SsoimageIdVideo.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1SsoimageIdVideo } from "../../clients/SSOImageController/postApiV1SsoimageIdVideo.ts";

export const postApiV1SsoimageIdVideoMutationKey = () =>
  [{ url: "/api/v1/ssoimage/:id/video" }] as const;

export type PostApiV1SsoimageIdVideoMutationKey = ReturnType<
  typeof postApiV1SsoimageIdVideoMutationKey
>;

export function postApiV1SsoimageIdVideoMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1SsoimageIdVideoMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1SsoimageIdVideoMutationKey();
  return mutationOptions<
    PostApiV1SsoimageIdVideoMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SsoimageIdVideo400
      | PostApiV1SsoimageIdVideo401
      | PostApiV1SsoimageIdVideo404
      | PostApiV1SsoimageIdVideo500
    >,
    {
      id: PostApiV1SsoimageIdVideoPathParams["id"];
      data: PostApiV1SsoimageIdVideoMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return postApiV1SsoimageIdVideo(id, data, config);
    },
  });
}

/**
 * @description Realiza o upload de um arquivo de vídeo para o Azure Blob Storage vinculado à SSOImage. O tamanho máximo é configurável via SSOImage:VideoMaxSizeMb em appsettings.json. **(Requer Authorization para autenticação)**
 * @summary Upload de vídeo SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id/video}
 */
export function usePostApiV1SsoimageIdVideo<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1SsoimageIdVideoMutationResponse,
      ResponseErrorConfig<
        | PostApiV1SsoimageIdVideo400
        | PostApiV1SsoimageIdVideo401
        | PostApiV1SsoimageIdVideo404
        | PostApiV1SsoimageIdVideo500
      >,
      {
        id: PostApiV1SsoimageIdVideoPathParams["id"];
        data: PostApiV1SsoimageIdVideoMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1SsoimageIdVideoMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1SsoimageIdVideoMutationKey();

  const baseOptions = postApiV1SsoimageIdVideoMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1SsoimageIdVideoMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SsoimageIdVideo400
      | PostApiV1SsoimageIdVideo401
      | PostApiV1SsoimageIdVideo404
      | PostApiV1SsoimageIdVideo500
    >,
    {
      id: PostApiV1SsoimageIdVideoPathParams["id"];
      data: PostApiV1SsoimageIdVideoMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1SsoimageIdVideoMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SsoimageIdVideo400
      | PostApiV1SsoimageIdVideo401
      | PostApiV1SsoimageIdVideo404
      | PostApiV1SsoimageIdVideo500
    >,
    {
      id: PostApiV1SsoimageIdVideoPathParams["id"];
      data: PostApiV1SsoimageIdVideoMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1SsoimageIdVideoMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SsoimageIdVideo400
      | PostApiV1SsoimageIdVideo401
      | PostApiV1SsoimageIdVideo404
      | PostApiV1SsoimageIdVideo500
    >,
    {
      id: PostApiV1SsoimageIdVideoPathParams["id"];
      data: PostApiV1SsoimageIdVideoMutationRequest;
    },
    TContext
  >;
}
